module.exports = __webpack_public_path__ + "static/media/user.fe45d664.svg";